import { post } from "./util";

/**
 * Indsendelse af virksomhedsblanketten gennem portalens FrontendAPI (ADV-297).
 *
 * Blanketten blev tidligere postet direkte til selskabsblanket-api's anonyme SendBlanket på
 * en anden APIM-host, uden credentials — så modtageren havde ingen mulighed for at vide hvem
 * der indsendte. Nu går den på den eksisterende cookie-session som enhver anden indberetning,
 * og backenden stempler AIKA-brugerens navn og brugeridentifikator på blanketten, samt
 * fuldmagtshaverens navn ved indsendelse under fuldmagt.
 *
 * Frontenden sender bevidst ingen identitetsoplysninger med: den har dem ikke, og hvis den
 * havde, kunne de spoofes. Svaret gentager heller ikke underskriveren.
 *
 * Almindelig `post` er det rigtige valg her, selvom denne fil på main brugte
 * `postWithoutAuthRedirect`. På main sendte `post` brugeren til logout på både 401 **og 403**,
 * og en 403 (fuldmagt uden Selskabsblanketten-rettigheden) må ikke smide medlemmet ud og kaste
 * en udfyldt blanket væk — derfor undtagelsen dér. Her redirecter interceptoren i `util.ts`
 * kun på 401, så `post` har allerede den egenskab; og en ægte udløbet session bliver håndteret
 * rigtigt, hvilket `postWithoutAuthRedirect` også slugte. 403 og 502 vises fortsat som
 * beskeder i formularen.
 */
export async function postSelskabsblanket(payload: object): Promise<void> {
  await post<{ message?: string }>({
    query: "Selskabsblanket/Send",
    body: payload,
  });
}
